import { useMemo } from "react";

import {
  EditGPDStartRegistrationTask,
  GPDStartRegistrationTask,
} from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { getFormObjectValues, initializeFormEditingState } from "@/helpers/helpers";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";
import { GpdStartRegistrationFormProps } from "@/types/form-types";

import { useGpdUiSchema } from "../../schema/gpd-ui-schema";

import { getGpdStartRegistrationSchema } from "./schema/gpd-start-registration-schema";

export function GpdStartRegistrationForm(props: GpdStartRegistrationFormProps) {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();
  const { type, oldUploadTask, task } = getFormObjectValues(props);

  const { isEditing, getIsEditing } = initializeFormEditingState(props);

  const { formData, handleChange } = useBrostarFormDataStorage<
    GPDStartRegistrationTask | EditGPDStartRegistrationTask
  >({ key: "gpd", task });

  const uiSchema = useGpdUiSchema(formData?.metadata.qualityRegime);
  const schema = useMemo(
    () => getGpdStartRegistrationSchema({ type, isEditing }),
    [type, isEditing]
  );

  const onSubmit = async () => {
    if (!formData) return;
    if (getIsEditing(formData)) {
      await api.editGpdStartRegistration(formData);
    } else {
      await api.createGpdStartRegistration(formData);
    }
    if (oldUploadTask?.uuid) api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <BrostarForm
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      onChange={handleChange}
      onSubmit={onSubmit}
      uploadTask={oldUploadTask}
    />
  );
}
